import React, { useContext } from 'react'
import { useSelector } from 'react-redux'
import HeaderItem from '../HeaderItem'
import Link from '../Link'
import styles from './HeaderLinks.module.sass'
import { getConfig } from 'src/features/config/ConfigSelector'
import Tag from '../Tag'
import useLaunchDarkly from 'src/features/launchDarkly/useLaunchDarkly'
import { SessionContext } from 'src/features/session/SessionContext'

const HeaderLinks = () => {
  const menuConfig = useSelector(getConfig('menus'))
  const menuItems = menuConfig?.main || []
  const { getFeatureFlagMenuItem } = useLaunchDarkly()
  const { userIsLibrarian = () => false } = useContext(SessionContext)

  return menuItems.map((menuItem, index) => {
    const item = getFeatureFlagMenuItem(menuItem)
    if (!item) return null

    let validatedLinks = item?.content

    if (Array.isArray(validatedLinks)) {
      validatedLinks = validatedLinks.filter(link => {
        if (link?.license_type === 'library') {
          return userIsLibrarian()
        }
        return true
      })
    }

    return item.group ? (
      <HeaderItem key={index} links={validatedLinks}>
        {item.group}
      </HeaderItem>
    ) : (
      <HeaderItem key={index}>
        <Link className={styles.link} to={item.to}>
          {item.label}
        </Link>
        {item.tag && <Tag className={styles.auxTag} label={item.tag} />}
      </HeaderItem>
    )
  })
}

export default HeaderLinks
